import { Suspense } from "react";
import SubscribeTrade, {
  SubscribePrice,
} from "@/market_page/component/trade/SubscribePrice";
import Chart from "./component/chart";

const ChartLite = () => {
  return (
    <Suspense>
      <Chart />
      <SubscribePrice />
      <SubscribeTrade />
    </Suspense>
  );
};

export default ChartLite;
